import { render, staticRenderFns } from "./tixian01_list.vue?vue&type=template&id=19ebd35b&scoped=true"
import script from "./tixian01_list.vue?vue&type=script&lang=js"
export * from "./tixian01_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ebd35b",
  null
  
)

export default component.exports